import { PurchaseOrderCreatePage } from "@/features/purchase-order/pages/PurchaseOrderCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/purchase-order/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["purchase_order.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PurchaseOrderCreatePage,
});
